import { apiClient } from './client'

/** Вид отсутствия: отпуск или каникулы. На генерацию уроков не влияет. */
export type AbsenceKind = 'vacation' | 'break'

export interface UserVacation {
  id: number
  user_id: number
  kind: AbsenceKind
  kind_label: string
  absence_status: 'on_vacation' | 'on_break'
  starts_on: string
  ends_on: string
  reason: string | null
  created_at?: string | null
  updated_at?: string | null
}

interface ApiResponse<T> {
  success?: boolean
  message?: string
  data?: T
}

export interface VacationPayload {
  kind?: AbsenceKind
  starts_on: string
  ends_on: string
  reason?: string | null
}

const BASE_URL = '/user/vacations'

export const vacationsApi = {
  list: async (): Promise<UserVacation[]> => {
    const response = await apiClient.get<ApiResponse<UserVacation[]>>(BASE_URL)
    return response.data?.data ?? []
  },

  create: async (payload: VacationPayload): Promise<UserVacation> => {
    const response = await apiClient.post<ApiResponse<UserVacation>>(BASE_URL, payload)
    if (!response.data?.data) throw new Error(response.data?.message || 'Ошибка сохранения отпуска')
    return response.data.data
  },

  update: async (id: number, payload: VacationPayload): Promise<UserVacation> => {
    const response = await apiClient.put<ApiResponse<UserVacation>>(`${BASE_URL}/${id}`, payload)
    if (!response.data?.data) throw new Error(response.data?.message || 'Ошибка сохранения отпуска')
    return response.data.data
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete<ApiResponse<unknown>>(`${BASE_URL}/${id}`)
  },

  /**
   * Отсутствия конкретного пользователя — карточка ученика у учителя.
   *
   * Отдельный вход от /user/vacations: там период заводится текущему
   * пользователю, здесь — указанному, и право сервер проверяет по
   * действующему договору.
   */
  listForUser: async (userId: number): Promise<UserVacation[]> => {
    const response = await apiClient.get<ApiResponse<UserVacation[]>>(`/users/${userId}/vacations`)
    return response.data?.data ?? []
  },

  createForUser: async (userId: number, payload: VacationPayload): Promise<UserVacation> => {
    const response = await apiClient.post<ApiResponse<UserVacation>>(`/users/${userId}/vacations`, payload)
    if (!response.data?.data) throw new Error(response.data?.message || 'Ошибка сохранения периода отсутствия')
    return response.data.data
  },
}
